<template>
  <section class="section resources-section reveal-section" id="recursos" ref="sectionRef">
    <div class="section-header">
      <span class="section-label">Descargables</span>
      <h2 class="section-title">Centro de Recursos</h2>
      <p class="section-subtitle">Materiales para tu crecimiento y desarrollo ministerial</p>
    </div>
    <div class="cards-grid">
      <div class="resource-card" v-for="(resource, i) in resources" :key="i">
        <div class="resource-icon" :style="{ background: resource.gradient }">
          <i :class="resource.icon"></i>
        </div>
        <h3>{{ resource.title }}</h3>
        <p>{{ resource.description }}</p>
        <a href="#" class="resource-btn" @click.prevent="showToast(resource.toast, 'info')">{{ resource.action }}</a>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useToast } from '@/composables/useToast';
import { useScrollReveal } from '@/composables/useAnimations';

const sectionRef = ref(null);
const { registerReveal } = useScrollReveal();
onMounted(() => registerReveal(sectionRef.value));

const { showToast } = useToast();

const resources = [
  { title: 'Guías de Estudio', description: 'Materiales completos para profundizar en temas bíblicos y de crecimiento espiritual.', icon: 'fas fa-book', gradient: 'linear-gradient(135deg, #5DADE2, #2a5ea8)', action: 'Descargar PDF', toast: 'Descargando guía de estudio...' },
  { title: 'Videotutoriales', description: 'Tutoriales paso a paso para implementar prácticas de liderazgo y ministerio efectivo.', icon: 'fas fa-video', gradient: 'linear-gradient(135deg, #FBA636, #e89520)', action: 'Ver Biblioteca', toast: 'Abriendo biblioteca de videos...' },
  { title: 'Plantillas', description: 'Plantillas listas para usar: planes de oración, planes de lectura, guías de reunión.', icon: 'fas fa-clipboard-list', gradient: 'linear-gradient(135deg, #3DC292, #1a8659)', action: 'Explorar', toast: 'Explorando plantillas...' },
  { title: 'Podcast Archivados', description: 'Accede a toda nuestra biblioteca de podcasts organizados por temas y series.', icon: 'fas fa-podcast', gradient: 'linear-gradient(135deg, #D45170, #AF1627)', action: 'Escuchar', toast: 'Abriendo archivo de podcasts...' },
  { title: 'Recursos Digitales', description: 'Gráficos, diseños y materiales para tus grupos y eventos ministeriales.', icon: 'fas fa-code', gradient: 'linear-gradient(135deg, #8E44AD, #5B2C6F)', action: 'Descargar', toast: 'Descargando recursos...' },
  { title: 'Recomendaciones de Lectura', description: 'Lista curada de libros y materiales que recomendamos para tu crecimiento integral.', icon: 'fas fa-book-reader', gradient: 'linear-gradient(135deg, #F39C12, #D68910)', action: 'Ver Lista', toast: 'Abriendo lista de lectura...' },
];
</script>

<style scoped>
.section { padding: 7rem 5%; }
.section-header { text-align: center; margin-bottom: 5rem; }
.section-label {
  display: inline-block; color: var(--vh-dorado);
  font-weight: 700; font-size: 0.8rem;
  text-transform: uppercase; letter-spacing: 3px;
  margin-bottom: 1rem; font-family: 'Barlow', sans-serif;
}
.section-title {
  font-size: clamp(2.2rem, 4vw, 3.2rem);
  color: var(--vh-azul-profundo);
  margin-bottom: 1.2rem; line-height: 1.1;
}
.section-subtitle {
  color: #666; max-width: 650px;
  margin: 0 auto; font-size: 1.15rem; line-height: 1.8;
}
.resources-section { background: var(--vh-gris-piedra); }
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}
.resource-card {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 5px 25px var(--vh-sombra);
  transition: var(--vh-transicion);
  border-top: 5px solid var(--vh-dorado);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}
.resource-card::before {
  content: '';
  position: absolute;
  top: 0; left: -100%;
  width: 100%; height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s;
}
.resource-card:hover::before { left: 100%; }
.resource-card:hover {
  transform: translateY(-12px) scale(1.01);
  box-shadow: 0 15px 50px var(--vh-sombra);
}
.resource-icon {
  width: 70px; height: 70px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: white;
  margin-bottom: 1.5rem;
  position: relative;
  z-index: 1;
  animation: float 3s ease-in-out infinite;
}
.resource-card h3 {
  font-size: 1.3rem;
  color: var(--vh-azul-profundo);
  margin-bottom: 0.8rem;
  position: relative;
  z-index: 1;
}
.resource-card p {
  color: #555;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  flex-grow: 1;
  position: relative;
  z-index: 1;
}
.resource-btn {
  display: inline-block;
  padding: 0.7rem 1.5rem;
  background: var(--vh-dorado);
  color: white;
  font-family: 'Barlow', sans-serif;
  font-weight: 600;
  border-radius: 50px;
  text-decoration: none;
  transition: var(--vh-transicion);
  font-size: 0.95rem;
  text-align: center;
  position: relative;
  z-index: 1;
}
.resource-btn:hover {
  background: var(--vh-dorado-hover);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(251, 166, 54, 0.3);
}
</style>
